module.exports = __webpack_public_path__ + "img/likesOrdered.e7360312.svg";